import modal from '../../common/modal'
import _ from '../../common/utility'

function topicAlert () {
    let checkSubURL, addSubURL, manageURL, name, id, addMessage, isEng;
    isEng = false;
    const $alert = $(".coe-v2").length ==0 ? $(`#topicAlert`) :$(`.add-email-alerts`) ;

    if (_.isCOE() && $(".coe-v2").length ==0) {
        addMessage = 'Subscribed to Email Alerts';
        isEng = window.locale !== 'us' ? true : false;
    }  else {
        addMessage = 'Added to Email Alerts';
    }

    if (qrllog === '0' || typeof DFPTargetKeys === 'undefined' || Number(DFPTargetKeys.pageSegVars.scg) === 0) {
        $alert.remove();
        return 0;
    }

    $().ready(function () {
        if (!isEng) {
            textSetup();
            alertSetup();
            modalSetup();
            $alert.addClass('active');
        }
    });

    function textSetup () {
        // conceptId and conceptName should come from global variable set in JSP
        id = conceptId || 0;
        name = conceptName || $('h1').text();
        checkSubURL = 'https://profreg.' + getDomain('profreg') + 'medscape.com/px/columns/checksubscription?conceptId=' + id;
        addSubURL =  'https://profreg.' + getDomain('profreg') + 'medscape.com/px/columns/addalert/1/' + id;
        manageURL = 'https://profreg.' + getDomain('profreg') + 'medscape.com/px/topicalert.do';
    }

    function alertSetup () {
        $.ajax({
            type: 'GET',
            url: checkSubURL,
            dataType:'jsonp'
        }).then(function(data){
            if (data.subscriptionCheck.topic) {
                $alert.html(addMessage);
            } else {
                if (_.isCOE()) {
                    $('#bodypadding').append(`
                        <section id="bottomTopicAlert" class="bottom-topic-alert">
                            <p>Stay connected. Subscribe to be notified when new content posts.</p>
                            <button type="button" id="bottomSubscribe">Subscribe</button>
                        </section>`);
                    $alert.html('Subscribe to Email Alerts');
                } else {
                    $('#bodypadding').append(`
                        <section id="bottomTopicAlert" class="bottom-topic-alert">
                            <p>Stay connected. Subscribe to be notified when new content posts.</p>
                            <button type="button" id="bottomSubscribe">Subscribe</button>
                        </section>`);
                    $alert.html('Add to Email Alerts');
                }
            }
            $('#topicAlert, #bottomSubscribe').click(function() {
                $.ajax({
                    type: 'GET',
                    url: addSubURL,
                    dataType:'jsonp'
                }).then(function(data){
                    if(data.subscriptionFeedback === 'subscription_successful'){
                        wmdPageLink('alrt-topc_newsub');
                    }
                    if(data.subscriptionFeedback === 'already_subscribed'){
                        wmdPageLink('alrt-topc_subd');
                    }
                    modal.showModal('js-topic-alert');
                    $alert.html(addMessage);
                    $('#bottomTopicAlert').remove();
                });
            });

        });
    }

    function modalSetup () {
        const $modal = $(`
            <div class="modal-layer inactive topic-alert" id="js-topic-alert">
                <div class="modal-content">
                    <div id="modalCloseIcon" class="close-modal black-icon"></div>
                    <p class="modal-confirm-text">You\'ve successfully added <b>${name}</b> to your alerts. You will receive email when new content is published.</p>
                    <a class="modal-confirm-link" href="${manageURL}" onclick="wmdTrack(\'alrt-topc_mgmt\');">Manage Email Alerts</a>
                    <button id="modalCloseButton" class="modal-close-button">Close</button>
                </div>
             </div>`);
        $(document).on('click', '#modalCloseIcon, #modalCloseButton', function (){
            modal.hideModal('js-topic-alert');
        });

        $('body').append($modal);

        const $tooltip = $(`
             <div class="alert-tooltip">
                <span class="alert-desc">Receive email when new articles are published on</span>
                <span class="alert-topic">${name}</span>
             </div>`);

        $alert.hover(() => {
            $alert.append($tooltip);
        }, () =>{
            $tooltip.detach();
        })
    }
}

export default _.catch(topicAlert);